<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <v-toolbar-title
        style="font-family: Arvo, serif; cursor: pointer;"
        @click="push()"
      >
        Parasha Source
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn :to="'/sheets/' + sefer" text rounded>Archives</v-btn>
      <v-btn to="/about" text rounded>
        About
      </v-btn>
    </v-app-bar>
    <v-main>
      <v-container style="margin-top: 20px;"><router-view /></v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      sefer: this.$store.state.parashah.sefer,
    };
  },
  async created() {
    this.$store.dispatch("getParashah");
  },
  methods: {
    push() {
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
    },
  },
};
</script>
